export const emptyFieldDash = (value: any): string | any => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
};
export const isEmpty = (value: any): boolean => {
  return value === null || value === undefined || value === '';
};
